import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth17postPostScreenTruthProposalsIdDecideResponseSchema = jsonObject
export type tcpscreentruth17postPostScreenTruthProposalsIdDecideResponse = z.infer<typeof tcpscreentruth17postPostScreenTruthProposalsIdDecideResponseSchema>
